import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IWarehouseDetail, IWarehouseSearchFields, warehouseService, IWarehouseInsert, IWarehouseUpdate } from "./warehouseService";
import { globalPrompt } from "@/components/message";
import { useGlobalModel, transPgToPagination } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { ISearchPage } from "@/types/AppTypes";

export const useWarehouseModel = createModel(function () {
    const { user: { shopCode, shopName, userName }, setLoadingInfo, warehouseloadDataAll } = useGlobalModel(({ user }) => [user]);
    const { sourceApp, branch } = defaultMdCmParam;
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IWarehouseDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IWarehouseSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IWarehouseDetail[]>([]);
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IWarehouseSearchFields = searchParam) => {
        const searchParams = {
            shopCode,
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await warehouseService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IWarehouseSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }


    //导出
    const exportWarehouse = async (searchValue: IWarehouseSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                shopCode,
                ...searchValue,
                id: selectedRowKeys.map(item => item.id)?.join(),
                pageSize: -1,
                pageNum: 1,
            };

            let result = await warehouseService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //下载模板
    const downloadTpl = async () => {
        let result = await warehouseService.downloadTpl();
        convertRes2Blob(result);
    }

    //启用 禁用 api
    const disableWarehouse = async (id: string, status: number) => {
        // let { retData } = await warehouseService.disable(id, status);
        // loadData()
        // globalPrompt("message", { text: "操作成功", type: "success" })
    };

    /**
     * 仓库新增
     */
    const [addWareVisible, setAddWaerVisible] = useState<boolean>(false);

    //仓库新增 Api
    const insertWarehouse = async (val: IWarehouseDetail) => {
        let data: IWarehouseInsert = {
            ...val,
            sourceApp, branch,
            shopCode, shopName,
            orgCode: shopCode,
            orgName: shopName,
            createTime:val.createTime instanceof Object ?  val.createTime.format('YYYY-MM-DDTHH:mm:ss') :null,
			updateTime:val.updateTime instanceof Object ?  val.updateTime.format('YYYY-MM-DDTHH:mm:ss') :null,
        }
        let { retData } = await warehouseService.insert(data);
        loadData();
        globalPrompt("message", { text: "仓库新增成功", type: "success" })
        warehouseloadDataAll();
        return retData;
    }


    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        addWareVisible, setAddWaerVisible,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportWarehouse,
        downloadTpl,
        disableWarehouse,
        insertWarehouse
    }
});